import axios from "axios";
import * as Constants from "../constant";
const editUser = async (id, role) => {
	try {
		const response = await axios.patch(
			`${Constants?.LOCAL_URL}/user-role/${id}`,
			role
		);
		return response.data[0];
	} catch (error) {
		return error;
	}
};
export default editUser;
